export const NET_SCORE_REQUEST = 'NET_SCORE_REQUEST';
export const NET_SCORE_FAILURE = 'NET_SCORE_FAILURE';
export const NET_SCORE_SUCCESS = 'NET_SCORE_SUCCESS';
